module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('p', {
    staticClass: "FMH"
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _c('a', {
    attrs: {
      "id": "page_ix"
    }
  }, [_c('span', {
    staticClass: "rh"
  }, [_vm._v("CONTENTS")])])]), _c('a', {
    attrs: {
      "id": "page_ix"
    }
  }, [_c('div', {
    staticClass: "FMRULE"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "image/51297.jpg"
    }
  })])]), _c('p', {
    staticClass: "CCT0"
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _c('a', {
    attrs: {
      "href": "#/ch01"
    }
  }, [_c('span', {
    staticClass: "cct1"
  }, [_vm._v("1. ")]), _vm._v("What LeBron James Has in Common with Pat Bradley")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('a', {
    attrs: {
      "href": "#/ch02"
    }
  }, [_c('span', {
    staticClass: "cct1"
  }, [_vm._v("2. ")]), _vm._v("Learning to Be Optimistic")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/ch03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "cct1"
  }, [_vm._v("3. ")]), _vm._v("A Confident Self-Image")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "cct1"
  }, [_vm._v("4. ")]), _vm._v("Respecting Your Talent")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "cct1"
  }, [_vm._v("5. ")]), _vm._v("Commitment, Perseverance, and Habit")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "cct1"
  }, [_vm._v("6. ")]), _vm._v("Dreams, Goals, and Process")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "cct1"
  }, [_vm._v("7. ")]), _vm._v("Being Single-Minded")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/ch08",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "cct1"
  }, [_vm._v("8. ")]), _vm._v("Learned Effectiveness: The Virtuous Circle")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/ch09",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "cct1"
  }, [_vm._v("9. ")]), _vm._v("Nerves and the Performance Process")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT4"
  }, [_c('span', {
    attrs: {
      "href": "#/ch10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "cct1"
  }, [_vm._v("10. ")]), _vm._v("Evaluating Yourself")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT3"
  }, [_c('span', {
    attrs: {
      "href": "#/ch11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "cct1"
  }, [_vm._v("11. ")]), _vm._v("Going Through the Fire")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT1"
  }, [_c('span', {
    attrs: {
      "href": "#/ch12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "cct1"
  }, [_vm._v("12. ")]), _vm._v("Working Hard, Working Smart")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT1"
  }, [_c('span', {
    attrs: {
      "href": "#/ch13",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "cct1"
  }, [_vm._v("13. ")]), _vm._v("When to Heed the Competition and When to Ignore It")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT4"
  }, [_c('span', {
    attrs: {
      "href": "#/ch14",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "cct1"
  }, [_vm._v("14. ")]), _vm._v("When to Be Patient and When to Be Impatient")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT1"
  }, [_c('span', {
    attrs: {
      "href": "#/ch15",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "cct1"
  }, [_vm._v("15. ")]), _vm._v("Surrounding Yourself with the Right People")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT1"
  }, [_c('span', {
    attrs: {
      "href": "#/ch16",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "cct1"
  }, [_vm._v("16. ")]), _vm._v("Doing What You Love or Loving What You Do?")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT1"
  }, [_c('span', {
    attrs: {
      "href": "#/ch17",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "cct1"
  }, [_vm._v("17. ")]), _vm._v("Sticking with Your Bread and Butter")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT1"
  }, [_c('span', {
    attrs: {
      "href": "#/ch18",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "cct1"
  }, [_vm._v("18. ")]), _vm._v("Creating Your Own Reality")])]), _vm._v(" "), _c('p', {
    staticClass: "CCTL"
  }, [_c('span', {
    attrs: {
      "href": "#/ch19",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "cct1"
  }, [_vm._v("19. ")]), _vm._v("A Life of Going for It")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT2"
  }, [_c('span', {
    attrs: {
      "href": "#/author_bio",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("About the Authors")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-21784071","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contents.vue
// module id = 66
// module chunks = 0